import StoryStorage from "../Storage/StoryStorage";

export default class ExperiencePoints {
  public ExpTable: Array<number> = new Array<number>(
    0,
    100,
    500,
    1500,
    5000,
    10000
  );

  public Level: number = 1;
  public ExperiencePoints: number = 0;
  private ExperienceTable: Array<number> = [];

  constructor(currenExp: number, expTable: Array<number> = []) {
    if (expTable.length > 0) {
      this.ExperienceTable = expTable;
    } else {
      this.ExperienceTable = this.ExpTable;
    }
    this.ExperiencePoints = currenExp;
    this.Level = this.calculateLevel(currenExp);
  }

  static create(): ExperiencePoints {
    const story = new StoryStorage();
    const currentExp = story.GetExp();
    return new ExperiencePoints(currentExp);
  }

  AddExp(exp: number): number {
    this.ExperiencePoints += exp;
    const prevLevel = this.Level;
    this.Level = this.calculateLevel(this.ExperiencePoints);
    // How many levels leveled up
    return this.Level - prevLevel;
  }

  /** Returns the XP threshold needed to reach the next level, or null if at max level. */
  GetNextLevelThreshold(): number | null {
    return this.ExperienceTable[this.Level] ?? null;
  }

  calculateLevel(currentExp: number): number {
    let level = 1;
    for (const expThreshold of this.ExperienceTable) {
      //Do not count threshhold 0 for a level up
      if (expThreshold != 0 && currentExp >= expThreshold) {
        level++;
      }
    }
    return level;
  }
}
